import { useState } from 'react'
import ColoredBar from './coloredBar'
import Container from './container'

export default function Marcas() {
  const [hoveredBrand, setHoveredBrand] = useState(null)

  const brands = [
    {
      id: 'omnicore',
      logo: '/assets/omnicore_logo.svg',
      alt: 'Omnicore',
      description:
        'Consultoria estratégica em soluções SAP, TOTVS e SENIOR. Padrão premium de suporte: menor burocracia, maior agilidade e foco total no sucesso do cliente.',
      glowColor: 'from-[#4B3BDB] to-[#362AA1]',
    },
    {
      id: 'behub',
      logo: '/assets/behub_logo.svg',
      alt: 'Be.hub',
      description:
        'Lideramos a implementação de metodologias e soluções ágeis personalizadas, conectando inovação e melhoria contínua em projetos.',
      glowColor: 'from-[#BC3FE5] to-[#792694]',
    },
    {
      id: 'nex2ai',
      logo: '/assets/next2ai_logo.svg',
      alt: 'Nex2.ai',
      description:
        'Somos especialistas no desenvolvimento de plataformas de gestão de dados, onde a IA otimiza o tempo e eleva a segurança no processamento das informações.',
      glowColor: 'from-[#FC0021] to-[#9E0015]',
    },
  ]

  return (
    <div className="w-full bg-[#040116] relative">
      <Container className="pt-[196px] pb-24 lg:py-32">
        <div className="flex flex-wrap justify-center items-start gap-8 md:gap-24">
          {brands.map(brand => {
            const isHovered = hoveredBrand === brand.id
            return (
              <div
                key={brand.id}
                className={`relative flex flex-col items-center ${
                  isHovered ? 'w-[330px] h-[330px]' : 'w-[250px]'
                } 
                                    transition-all duration-300 rounded-lg overflow-hidden cursor-pointer`}
                onMouseEnter={() => setHoveredBrand(brand.id)}
                onMouseLeave={() => setHoveredBrand(null)}
              >
                {/* Blur effect background - enhanced */}
                {isHovered && (
                  <>
                    <div className="absolute inset-0 bg-[#1B182D] z-0" />
                    <div
                      className={`absolute bottom-0 left-0 w-full h-[40%] bg-gradient-to-t ${brand.glowColor} opacity-80 blur-3xl z-0`}
                    />
                  </>
                )}

                {/* Card content with border */}
                <div
                  className={`relative z-10 w-full h-full flex flex-col items-center ${
                    isHovered ? 'border border-white/80 rounded-lg p-8' : 'px-2 py-4'
                  } 
                                        transition-all duration-300 ${
                                          isHovered ? '' : 'bg-transparent'
                                        }`}
                >
                  <div className="h-12 flex items-center justify-center mb-8">
                    <img
                      src={brand.logo}
                      alt={brand.alt}
                      className={
                        brand.id === 'behub' ? 'w-[180px]' : 'w-[250px]'
                      }
                    />
                  </div>

                  {isHovered && (
                    <div className="flex flex-row text-white mt-4 mb-8">
                      <span className="text-5xl -mt-1">*</span>
                      <p className="text-lg font-inter-regular leading-6 mb-2 flex">
                        <span className="ml-2">{brand.description}</span>
                      </p>
                    </div>
                  )}

                  {!isHovered && (
                    <div className="">
                      <div className="relative group">
                        <div className="absolute inset-0 rounded-full bg-transparent" />
                        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] p-[1px]">
                          <div className="absolute inset-[1px] rounded-full bg-[#040116]" />
                        </div>
                        <div className="relative px-5 py-2 rounded-full flex items-center gap-2 text-white z-10">
                          <span className="text-xs font-inter-light">
                            Ver mais
                          </span>
                          <img
                            src="../assets/arrow_forward.svg"
                            className="self-center w-3 h-3"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </Container>

      {/* Colored bar that changes based on hovered brand */}
      <ColoredBar hoveredBrand={hoveredBrand} brands={brands} />
    </div>
  )
}
